/**
 * Centralized Configuration
 * Single source of truth for all API URLs and base URLs
 */

class AppConfig {
  constructor() {
    this._initialized = false;
    this._apiUrl = null;
    this._baseUrl = null;
  }

  /**
   * Initialize configuration
   * Should be called once when app starts
   */
  initialize() {
    if (this._initialized) return;
    
    // Get API URL from runtime config or environment
    if (window.APP_CONFIG && typeof window.APP_CONFIG.getApiUrl === 'function') {
      this._apiUrl = window.APP_CONFIG.getApiUrl();
    } else {
      this._apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000/api/v1';
    }
    
    // Extract base URL (remove /api/v1)
    this._baseUrl = this._apiUrl.replace('/api/v1', '');
    
    this._initialized = true;
    
    console.log('[AppConfig] Initialized:', {
      apiUrl: this._apiUrl,
      baseUrl: this._baseUrl
    });
  }

  /**
   * Get API base URL (e.g., http://172.16.10.126:5000/api/v1)
   */
  getApiUrl() {
    if (!this._initialized) this.initialize();
    return this._apiUrl;
  }

  /**
   * Get server base URL for static files (e.g., http://172.16.10.126:5000)
   */
  getBaseUrl() {
    if (!this._initialized) this.initialize();
    return this._baseUrl;
  }

  /**
   * Get full URL for an image path
   * @param {string} imagePath - Path like /uploads/faces/123.jpg
   * @returns {string} Full URL
   */
  getImageUrl(imagePath) {
    if (!imagePath) return '';
    if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
      return imagePath; // Already full URL
    }
    return `${this.getBaseUrl()}${imagePath}`;
  }

  /**
   * Reload configuration (useful when changing URL at runtime)
   */
  reload() {
    this._initialized = false;
    this.initialize();
  }
}

// Export singleton instance
const appConfig = new AppConfig();
export default appConfig;
